import { createFileRoute } from "@tanstack/solid-router";
import { onMount } from "solid-js";
import { useAuth } from "~/lib/auth";

export const Route = createFileRoute("/auth/register")({
  component: RegisterPage,
});

function RegisterPage() {
  const auth = useAuth();

  onMount(() => {
    auth.register();
  });

  return (
    <div class="min-h-screen flex items-center justify-center">
      <div class="flex flex-col items-center gap-3 text-muted-foreground">
        <div class="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p class="text-sm">Redirecting to registration…</p>
      </div>
    </div>
  );
}
